import React from 'react';
import { CheckCircle, Ban, AlertTriangle, Delete, Save } from 'lucide-react';

const StatusChip = ({ status }) => {
  const statusConfig = {
    'Activo': { color: 'bg-green-100 text-green-800', icon: <CheckCircle className="w-3 h-3 mr-1" /> },
    'activo': { color: 'bg-green-100 text-green-800', icon: <CheckCircle className="w-3 h-3 mr-1" /> },
    'Suspendido': { color: 'bg-amber-100 text-amber-800', icon: <Ban className="w-3 h-3 mr-1" /> },
    'suspendido': { color: 'bg-amber-100 text-amber-800', icon: <Ban className="w-3 h-3 mr-1" /> },
    'pendiente': { color: 'bg-amber-100 text-amber-800', icon: <AlertTriangle className="w-3 h-3 mr-1" /> },
    'aceptado': { color: 'bg-green-100 text-green-800', icon: <CheckCircle className="w-3 h-3 mr-1" /> },
    'rechazado': { color: 'bg-red-100 text-red-800', icon: <Ban className="w-3 h-3 mr-1" /> },
    'resuelto': { color: 'bg-blue-100 text-blue-800', icon: <CheckCircle className="w-3 h-3 mr-1" /> },
    'eliminado': { color: 'bg-red-100 text-red-800', icon: <Delete className="w-3 h-3 mr-1" /> },
    'Vendido': { color: 'bg-blue-100 text-blue-800', icon: <Save className="w-3 h-3 mr-1" /> },
    'Alquilado': { color: 'bg-blue-100 text-blue-800', icon: <Save className="w-3 h-3 mr-1" /> },
    'inactivo': { color: 'bg-gray-100 text-gray-800', icon: <Ban className="w-3 h-3 mr-1" /> }
  };
  
  const config = statusConfig[status] || { color: 'bg-gray-100 text-gray-800', icon: null };
  
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`}>
      {config.icon}
      {status}
    </span>
  );
};

export default StatusChip;